import {
  CustomOperation,
  OrderGiftCardProduct,
  OrderGiftCardProductRetain24,
  OrderHistoryLogEntry,
  OrderLine
} from "lib/types/generated/graphql-types"
import { ReasonType } from "lib/types/order"

export const formatOperation = (operation: string) => {
  switch (operation) {
    case CustomOperation.Delivery:
      return "Delivery"
    case CustomOperation.Refund:
      return "Refund"
    case CustomOperation.Release:
      return "Release"
    case CustomOperation.Compensation:
      return "Compensation"
    case CustomOperation.Cancellation:
      return "Cancellation"
    case CustomOperation.ModifyOrderLines:
      return "Modify order lines"
    case CustomOperation.ModifyShippingFees:
      return "Modify shipping fees"
    case CustomOperation.ModifyOrderAddresses:
      return "Modify order addresses"
    default:
      return operation
  }
}

export const getMessage = (entry: OrderHistoryLogEntry, isOrderPaymentQliroOne: boolean) => {
  if (entry.type === "ADD_CUSTOM_STATE") return "Added custom state"
  if (entry.type === "REMOVE_CUSTOM_STATE") return "Removed custom state"
  if (entry.type === "ADD_COMMENT") return "Added comment"
  if (entry.status === "CAPTURE_PAYMENT_FAILURE" && entry.message && !entry.errorMessage)
    return "capturing payment failed"

  if (isOrderPaymentQliroOne) {
    if (
      entry.type === "CAPTURE_PAYMENT" ||
      entry.type === "REFUND_PAYMENT" ||
      entry.type === "CANCEL_PAYMENT" ||
      entry.type === "RELEASE_PAYMENT"
    )
      return entry?.message?.replace(/[0-9]/g, "")
  }

  return entry.message
}

export const getFormattedState = (state: string) => {
  switch (state) {
    case "FULLY_DELIVERED":
      return "Delivered"
    case "PARTIALLY_DELIVERED":
      return "Delivered in part"
    case "PARTIALLY_REFUNDED":
      return "Refunded in part"
    case "FULLY_REFUNDED":
      return "Refunded"
    case "FULLY_COMPENSATED":
      return "Compensated"
    case "PARTIALLY_COMPENSATED":
      return "Compensated in part"
    case "CANCELLED":
      return "Cancelled"
    case "PLACED":
      return "Placed"
    case "RELEASED":
      return "Released"
    default:
      return state
  }
}

export const getTotalWeight = (orderLines: OrderLine[]) => {
  return orderLines?.reduce((a, line) => a + (line?.weight ?? 0) * line?.quantity, 0)
}

export function isOrderGiftCardProductRetain24(
  object: OrderGiftCardProduct
): object is OrderGiftCardProductRetain24 {
  return object?.providerName === "Retain24"
}

export function isSkipReason(type: ReasonType | undefined): boolean {
  return type === ReasonType.SKIP
}

export const truncateUrl = (url: string, maxLength: number = 50) => {
  if (url.length <= maxLength) return url

  const ellipsis = "..."
  const visibleChars = maxLength - ellipsis.length
  const start = Math.ceil(visibleChars / 2)
  const end = Math.floor(visibleChars / 2)

  return `${url.slice(0, start)}${ellipsis}${url.slice(-end)}`
}

